module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/video_preview-009b486f7e0e6d0c00280b3151e00e78.jpg";